import React from "react";
import { Switch, SwitchProps } from "@mui/joy";
import { theme } from "styles/theme";

// 프로젝트 공통 Switch.
// 트랙 30x18 / 썸 14 / off=Surface.Backward + thumb=Content.Negative,
// on=Content.Highlight. 테두리/그림자 없음.
export default function CustomSwitch(props: SwitchProps) {
  const { checked, sx, ...rest } = props;

  return (
    <Switch
      size="sm"
      color={checked ? "primary" : "neutral"}
      checked={checked}
      {...rest}
      sx={[
        {
          "--Switch-trackWidth": "30px",
          "--Switch-trackHeight": "18px",
          "--Switch-thumbSize": "14px",
          "& .MuiSwitch-track": {
            backgroundColor: theme.vars.palette.Surface.Backward,
            border: "none",
            boxShadow: "none",
          },
          "&.Mui-checked .MuiSwitch-track": {
            backgroundColor: theme.vars.palette.Content.Highlight,
            border: "none",
            boxShadow: "none",
          },
          "& .MuiSwitch-thumb": {
            backgroundColor: theme.vars.palette.Content.Negative,
            border: "none",
            boxShadow: "none",
          },
          "&.Mui-checked .MuiSwitch-thumb": {
            border: "none",
            boxShadow: "none",
          },
        },
        ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
      ]}
    />
  );
}
